var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-controls"},[_c('div',{staticClass:"account-controls__icon"},[(_vm.contactPhoto)?_c('img',{staticClass:"account-controls__image",attrs:{"src":_vm.contactPhoto,"heigt":"24","width":"24"}}):_c('span',{staticClass:"account-controls__initials"},[_vm._v(_vm._s(_vm.userInitials))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }